export default [
  {
    path: '/whatsapp-ads',
    name: 'marketing',
    component: () => import('@/views/pages/komads/List.vue'),
    meta: {
      resource: 'Marketing',
      action: 'manage',
    },
  },
  {
    path: '/whatsapp-ads/balance-history',
    name: 'marketing-balance-history',
    component: () => import('@/views/pages/komads/HistoryBalance.vue'),
    meta: {
      resource: 'Marketing',
      action: 'manage',
      navActiveLink: 'marketing',
    },
  },
  {
    path: '/whitelisted-account',
    name: 'whitelisted-account',
    component: () => import('@/views/pages/komads/WhitelistedAccount.vue'),
    meta: {
      resource: 'Whitelisted Account',
      action: 'manage',
      navActiveLink: 'whitelisted-account',
    },
  },
  {
    path: '/categories-detail',
    name: 'categories-detail-komads',
    component: () => import('@/views/pages/komads/DetailCategory.vue'),
    meta: {
      resource: 'Marketing',
      action: 'manage',
      navActiveLink: 'marketing',
    },
  },
]
